module.exports = __webpack_public_path__ + "static/media/beeyay-badge.20491ff0.png";